function toPersianNum( num, comma ,convert ) {

    var i = 0;

    var comma = comma || false;
    var convert = convert || 1;
    var num;

    if(convert != 1){
     num = num*convert;
     num = num.toString().split('.');
     num = num[0] + '.' + num[1].substring(0,2);
    }
    num = comma ? num.toString() : num.toString().trim();
    num = comma ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : num;
    var len = num.length;

    var res = '';
    var pos;

    var persianNumbers = typeof persianNumber == 'undefined' ?
        ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
        persianNumbers;

    
    if(convert == 1)   
        for (; i < len; i++)
            if (( pos = persianNumbers[num.charAt(i)] ))
                res += pos;
            else
                res += num.charAt(i);
    else res = num

    return res;
}


export default {
    methods: {
        toPersianNum
      }
}
